import { useTranslation } from 'react-i18next';
import { generatePath, Link } from 'react-router-dom';

import { company } from '~/company/Company';
import Icon from '~/components/Icon/Icon';
import { ROUTES } from '~/pages/Root/constants';

import parentStyles from '../../OrderPayment.module.scss';

import styles from './PaymentSuccess.module.scss';

interface PaymentSuccessProps {
  orderId: string;
}

export const PaymentSuccess = ({ orderId }: PaymentSuccessProps) => {
  const { t } = useTranslation();

  return (
    <>
      <div className={styles.successBody}>
        <Icon type="pack" size={200} className={styles.packIcon} />
        <h1>{t('paymentSuccessful')}</h1>
        <p>{t('paymentSuccessfulDescription')}</p>
      </div>
      <div className={parentStyles.orderPaymentPageContentButtons}>
        <Link to={ROUTES.shop} className="button _primary product-card__buy _m">
          {t('goShopping')}
        </Link>
        <Link
          to={generatePath(ROUTES.order, { orderId })}
          className="button _bordered product-card__buy _m"
        >
          {t('trackOrder')}
        </Link>
        {company.hasContactSupport && company.config.links?.whatsapp && (
          <a
            href={company.config.links.whatsapp}
            target="_blank"
            rel="noopener noreferrer"
            className="button _bordered product-card__buy _m"
          >
            {t('contactSupport')}
          </a>
        )}
      </div>
    </>
  );
};
